import { Data, Keys, Variant } from "../textInterfaces";

import { TextManager } from "../TextManager";
import { Variants } from "../textConstants";

export const getComponentWrapper = (
  componentId: Keys,
  variant: Variant = Variants.BASE,
): Data | undefined => {
  try {
    return TextManager.getComponent(variant, componentId);
  } catch (error) {
    return undefined;
  }
};
